import { Reveal } from "./Reveal";
import { useLang } from "../i18n/LanguageContext";

const IMAGES = [
  "/resto-gal-1.webp",
  "/resto-gal-2.webp",
  "/resto-gal-3.webp",
  "/resto-gal-4.webp",
  "/resto-gal-5.webp",
];

export const RestaurantCarousel = () => {
  const { t } = useLang();
  const loop = [...IMAGES, ...IMAGES];

  return (
    <section
      data-testid="restaurant-carousel"
      className="relative py-24 sm:py-32 overflow-hidden"
      style={{ background: "var(--color-bg)" }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 mb-12 sm:mb-16">
        <Reveal className="max-w-2xl">
          <p className="text-[11px] tracking-[0.3em] uppercase mb-4" style={{ color: "var(--color-text-muted)" }}>
            {t.common.galleryOverline}
          </p>
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-[\'Playfair_Display\']" style={{ color: "var(--color-dark)" }}>
            {t.common.galleryTitle}{" "}
            <span className="italic opacity-80">{t.common.galleryTitleItalic}</span>
          </h2>
        </Reveal>
      </div>

      <div className="relative w-full overflow-hidden carousel-mask" data-testid="carousel-viewport">
        <div className="carousel-track flex gap-5 sm:gap-6 w-max px-6 lg:px-8">
          {loop.map((src, i) => (
            <div
              key={i}
              data-testid={`carousel-slide-${i}`}
              className="relative flex-shrink-0 w-[240px] sm:w-[320px] lg:w-[360px] aspect-[3/4] rounded-3xl overflow-hidden shadow-[0_24px_60px_rgba(44,30,22,0.14)]"
            >
              <img
                src={src}
                alt="La Caravelle · Narbonne"
                loading="lazy"
                className="w-full h-full object-cover"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
